module.exports = __webpack_public_path__ + "static/media/news_gothic_bt.daf65b69.woff2";